<script context="module">
  export let i18n = {
    sv: {
      'registered trademark': 'registrerat varumärke',
      'Subscribe to our newsletter': 'Prenumerera på vårt nyhetsbrev',
      'Get a periodical summary of what we’ve been up to.':
        'Få en periodisk sammanfattning av vad vi har gjort på sistone.',
      'By subscribing, I agree to receive communications from All Aboard.':
        'Genom att prenumerera godkänner jag att ta emot kommunikation från All Aboard.',
      'Thanks!': 'Tack!',
      Email: 'E-post'
    },
    da: {
      'registered trademark': 'registreret varemærke'
    },
    de: {
      'registered trademark': 'registrierte Marke',
      'Subscribe to our newsletter': 'Abonnieren Sie unseren Newsletter',
      'Get a periodical summary of what we’ve been up to.':
        'Erhalten Sie eine periodische Zusammenfassung dessen, was wir gemacht haben.',
      'By subscribing, I agree to receive communications from All Aboard.':
        'Durch das Abonnieren stimme ich zu, dass ich Kommunikation von All Aboard erhalte.',
      'Thanks!': 'Danke!',
      Email: 'E-Mail'
    },
    fr: {
      'registered trademark': 'marque déposée',
      'Subscribe to our newsletter': 'Abonnez-vous à notre newsletter',
      'Get a periodical summary of what we’ve been up to.':
        'Recevez un résumé périodique de ce que nous avons fait.',
      'By subscribing, I agree to receive communications from All Aboard.':
        'En m’abonnant, j’accepte de recevoir des communications de All Aboard.',
      'Thanks!': 'Merci!',
      Email: 'E-mail'
    },
    es: {
      'registered trademark': 'marca registrada',
      'Subscribe to our newsletter': 'Suscríbete a nuestro boletín',
      'Get a periodical summary of what we’ve been up to.':
        'Recibe un resumen periódico de lo que hemos estado haciendo.',
      'By subscribing, I agree to receive communications from All Aboard.':
        'Al suscribirme, acepto recibir comunicaciones de All Aboard.',
      'Thanks!': '¡Gracias!',
      Email: 'E-mail'
    }
  }
</script>

<script>
  import { asText } from '@prismicio/helpers'
  import { enhance } from '$app/forms'
  import { page } from '$app/stores'

  import { text, register } from '$lib/text.js'
  import { prefix } from '$lib/utils/prefix.js'
  import { resolve } from '$lib/prismic.js'
  import Logo from '$lib/Logo.svelte'

  register(i18n)

  export let internal = false
  export let newsletter = !internal

  $: settings = $page.data.settings
</script>

{#if settings}
  <footer class="footer" class:internal>
    <div class="container u-container">
      {#if !internal}
        <div class="sections">
          <div class="logo">
            <Logo horizontal />
          </div>
          <div class="lists">
            {#each settings.data.footer as slice}
              {@const { slice_type, primary, items } = slice}
              {#if !internal && slice_type === 'link_list'}
                {@const links = items
                  .filter(
                    (item) =>
                      (item.link?.url || !item.link.isBroken) &&
                      (item.label || item.link.data.title)
                  )
                  .map(function ({ label, link }) {
                    if (!label) label = asText(link.data.title)
                    const href = resolve(link)
                    return { label, href }
                  })}
                <nav class="section links">
                  <strong class="title">
                    {asText(primary.heading)}
                  </strong>
                  <ul>
                    {#each links as { label, href }}
                      <li class="item">
                        <a class="link" {href}>{label}</a>
                      </li>
                    {/each}
                  </ul>
                </nav>
              {/if}
            {/each}
          </div>
          {#if newsletter && !internal && settings.data.enable_newsletter}
            <form
              method="POST"
              class="newsletter"
              action="?/newsletter"
              use:enhance>
              <p>
                <strong class="title">
                  {$text`Subscribe to our newsletter`}
                </strong>
                {$text`Get a periodical summary of what we’ve been up to.`}
              </p>
              <div class="control">
                <label for="footer-full-name" class="u-hidden">
                  {$text`Email`}
                </label>
                <input
                  tabindex="-1"
                  class="input"
                  type="text"
                  name="full-name"
                  autocomplete="off"
                  id="footer-full-name" />
              </div>
              <div class="control">
                <label for="footer-email" class="u-hidden">
                  {$text`Email`}
                </label>
                <input
                  class="input"
                  type="email"
                  name="email"
                  id="footer-email"
                  autocomplete="email"
                  placeholder={$page.form?.subscribed
                    ? $text`Thanks!`
                    : $text`Email`}
                  required />
                <button class="button" type="submit">
                  Submit email
                  <svg viewBox="0 0 127.562 127.5">
                    <path
                      fill="currentcolor"
                      d="m63.75 127.5c34.875 0 63.75-28.9375 63.75-63.75 0-34.875-28.9375-63.75-63.8125-63.75-34.8125 0-63.6875 28.875-63.6875 63.75 0 34.8125 28.9375 63.75 63.75 63.75zm0-10.625c-29.5 0-53.0625-23.625-53.0625-53.125s23.5-53.125 53-53.125 53.1875 23.625 53.1875 53.125-23.625 53.125-53.125 53.125z" />
                    <path
                      fill="currentcolor"
                      d="m95.8125 63.6875c0-1.375-.5-2.375-1.75-3.625l-21.125-21.25c-.8125-.8125-1.9375-1.25-3.25-1.25-2.5625 0-4.5 1.9375-4.5 4.5 0 1.375.5625 2.5 1.375 3.375l7.8125 7.75 7.5625 6.3125-13.1875-.5h-32.625c-2.6875 0-4.6875 1.9375-4.6875 4.6875 0 2.6875 2 4.625 4.6875 4.625h32.625l13.1875-.4375-7.5625 6.3125-7.8125 7.75c-.875.8125-1.375 1.9375-1.375 3.3125 0 2.5625 1.9375 4.5625 4.5 4.5625 1.3125 0 2.4375-.5 3.25-1.3125l21.125-21.1875c1.1875-1.125 1.75-2.25 1.75-3.625z" />
                  </svg>
                </button>
              </div>
              <small>
                {$text`By subscribing, I agree to receive communications from All Aboard.`}
              </small>
            </form>
          {/if}
        </div>
      {/if}
      <div class="end">
        <p class="terms">
          {#each settings.data.legal_links as item}
            {@const href = resolve(item.link, $prefix)}
            {#if href}
              <a {href}>{item.link_label}</a>
            {/if}
          {/each}
        </p>
        <p class="copy">
          <span class="u-nowrap">
            <span class="sign">©</span>
            {new Date().getFullYear()} All Aboard AB
          </span>
          <span class="u-nowrap">
            <span class="sign">®</span>
            All Aboard, {$text`registered trademark`}
          </span>
        </p>
      </div>
    </div>
  </footer>
{/if}

<style>
  .footer {
    padding: 4rem 0 2.5rem;
    font-size: 1rem;
    line-height: 1.3;
    background: var(--current-background, rgb(var(--rgb-bright-gray)));
  }

  @media (width > 600px) {
    .footer {
      padding-top: 5rem;
    }
  }

  @media (width > 1000px) {
    .footer {
      padding: 5.5rem 0 3rem;
    }
  }

  .internal {
    padding: 1.25rem 0;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    position: relative;
  }

  a {
    color: rgb(var(--rgb-muted));
    transition: var(--color-transition);
  }

  a:hover {
    color: rgb(var(--rgb-text));
  }

  /* Sections */

  .sections {
    display: grid;
    gap: 3.5rem 1.5rem;
    width: 100%;
  }

  @media (width > 600px) {
    .sections {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (width > 800px) {
    .sections {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (width > 1200px) {
    .sections {
      grid-template-columns: repeat(5, 1fr) 1rem;
    }
  }

  /* Logo */

  .logo {
    height: 3rem;
    overflow: hidden;
    grid-column: span 1;
    aspect-ratio: 1.15;
  }

  /* Lists */

  .lists {
    display: grid;
    gap: 3rem 2rem;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    width: 100%;
    user-select: none;
  }

  @media (width > 600px) {
    .lists {
      grid-column: span 2;
    }
  }

  @media (width > 800px) {
    .lists {
      grid-column: span 3;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 1fr 1fr;
    }
  }

  .title {
    display: block;
    font-weight: 700;
    margin-bottom: 0.9rem;
  }

  li + li {
    margin-top: 0.6rem;
  }

  /* Newsletter */

  .newsletter {
    text-wrap: balance;
    border-top: 1px solid rgba(var(--rgb-gray), 0.3);
    padding-top: 3rem;
  }

  @media (width > 600px) {
    .newsletter {
      grid-column: 2 / 4;
      padding-top: 0.5rem;
      margin-top: 0;
      border-top: 0;
    }
  }

  @media (width > 800px) {
    .newsletter {
      grid-column: 2 / 5;
    }
  }

  @media (width > 1200px) {
    .newsletter {
      grid-column: span 2;
      padding-top: 0;
    }
  }

  .control {
    max-width: 18rem;
    position: relative;
    margin: 1rem 0 0.5rem;
  }

  input {
    width: 100%;
    height: 3rem;
    padding: 0 2.5rem 0 1.25rem;
    font-size: 1rem;
    border-radius: var(--border-radius-md);
    border: 2px solid rgb(var(--rgb-gray));
    transition: border-color 150ms var(--ease);
  }

  /* Honeypot */
  .control:has(input[name='full-name']) {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 1px;
    height: 1px;
    opacity: 0;
  }

  input:focus {
    border-color: rgb(var(--rgb-text));
  }

  input::placeholder {
    color: rgb(var(--rgb-muted));
  }

  button {
    position: absolute;
    right: 0.8rem;
    top: 50%;
    font-size: 0;
    color: transparent;
    transform: translateY(-50%);
    width: 1.5rem;
    color: rgb(var(--rgb-gray));
    transition: color 150ms var(--ease);
  }

  button svg {
    display: block;
    width: 100%;
  }

  button:hover {
    color: rgb(var(--rgb-text));
  }

  small {
    display: block;
    max-width: 20rem;
    font-size: 0.75rem;
    color: rgb(var(--rgb-muted));
    opacity: 0.8;
  }

  /* End section */

  .end {
    width: 100%;
    font-size: 0.875rem;
    color: rgb(var(--rgb-muted));
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .sections + .end {
    padding-top: 2rem;
    margin-top: 3rem;
    border-top: 1px solid rgba(var(--rgb-gray), 0.3);
  }

  .copy {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .terms a::after {
    content: ', ';
  }

  .terms a:last-child::after {
    content: none;
  }

  .sign {
    font-family: arial, sans-serif;
  }

  @media (width > 900px) {
    .end {
      flex-direction: row;
      justify-content: space-between;
      gap: 0.5rem;
    }

    .sections + .end {
      margin-top: 4rem;
    }

    .terms a {
      margin-right: 1.25rem;
    }

    .terms a::after {
      content: none;
    }
  }
</style>
